import elasticsearchService from './services/elasticsearchService.js';
import pinPointerImg from './../../images/meeting_points/pin-pointer.png'
import meetingPointImg from './../../images/meeting_points/meeting-point.png'
import activeMeetingPointImg from './../../images/meeting_points/active-meeting-point.png'

var marker_url = {
    pin_pointer: pinPointerImg,
    meeting_point: meetingPointImg,
    active_meeting_point: activeMeetingPointImg
};

var legacy_url = "https://account.envoituresimone.com";

if (window.location.hostname.includes('staging')){
    legacy_url = "https://dev.envoituresimone.com";
} else if (window.location.hostname.includes('localhost')) {
    legacy_url = "http://localhost:3000";
}

const minLengthPassword = 6

var changeQuantity = function() {
    $(".select_quantity-js select").change(function() {
        // get quantity chosen, add or replace param quantity to url
        var quantity = $(this).val();
        var current_url = new URL(window.location.href);
        current_url.searchParams.set('quantity', quantity);
        window.location.replace(current_url.toString());
    });
}

var getLocations = function(requested_address) {
    let elasticsearch = new elasticsearchService();

    let params = {};
    if (requested_address.lat && requested_address.lng) {
        params = {
            lat: requested_address.lat,
            lng: requested_address.lng
        }
    }

    let data = elasticsearch.searchLocation(params);
    if (data["hits"]) {
        data = data["hits"]
    }

    return data
};

var setInfoWindow = function (location) {
    let info_window = null;
    if (location['name'] == location['city']) {
        info_window = location['city'] + " - " + location['line_1']
    } else {
        info_window = location['city'] + " - " + location['name']
    }
    return info_window
};

var getMeetingPoints = function(requested_address) {
    var meetingPoints = [];
    let locations = getLocations(requested_address);
    if (locations) {
        locations.forEach(function(location){
            meetingPoints.push({
                "location_id": location["id"],
                "lat": location["coordinates"][1],
                "lng": location["coordinates"][0],
                "picture": {
                    "url": marker_url.meeting_point,
                    "width": 30,
                    "height": 40
                },
                "infowindow": setInfoWindow(location),
                "name": location["name"],
                "distance": location["distance"],
                "zipcode": location["zipcode"],
                "line_1": location["line_1"],
                "city": location["city"]
            });
        })
    }
    if (requested_address.lat && requested_address.lng) {
        meetingPoints.push({
            "lat": requested_address.lat,
            "lng": requested_address.lng,
            "picture": {
                "url": marker_url.pin_pointer,
                "width": 30,
                "height": 42
            },
            "infowindow": "Vous êtes ici"
        });
    }
    return meetingPoints
};

function infoPointRdv(point) {
    let info = $("#choisir-point-rdv-info");
    info.show();
    let text = "</br><p>Vous avez choisi: [POINT]</p>";
    let rep = text.replace('[POINT]', point.infowindow);
    info.html(rep);
}

var initMap = function(meetingPoints, requested_address) {
    var map_elem = document.getElementById('tunnel-map-js');

    if (map_elem) {
        let markers = [];
        let mapOptions = {
            styles: [{
                featureType: "poi",
                stylers: [{ visibility: "off" }]
            }],
            disableDefaultUI: true,
            zoomControl: true
        };
        let map = new google.maps.Map(map_elem, mapOptions);
        let bounds = new google.maps.LatLngBounds();
        var info_window = null;

        meetingPoints.forEach(function(data) {

            let marker = new google.maps.Marker({
                position: {lat: data["lat"], lng: data["lng"]},
                animation: google.maps.Animation.DROP,
                map: map,
                draggable: false,
                icon: data["picture"]["url"]
            });
            bounds.extend(marker.position);
            markers.push(marker);
            google.maps.event.addListener(marker, 'click', function() {
                if (info_window) {
                    info_window.close();
                }
                info_window = new google.maps.InfoWindow({ content: data.infowindow});
                info_window.open(map, marker);
                if ((data['lat'] != requested_address.lat) && (data['lng'] != requested_address.lng)) {
                    infoPointRdv(data)
                    $('#choisir-point-rdv-location_id').val(data.location_id);
                    for (var j = 0; j < markers.length; j++) {
                        if (markers[j].icon != marker_url.pin_pointer) {
                            markers[j].setIcon(marker_url.meeting_point);
                        }
                    }
                    marker.setIcon(marker_url.active_meeting_point);
                }
            })
        }.bind(this));

        map.fitBounds(bounds);
        map.panToBounds(bounds);
    }
};

var showGoogleMap = function() {
    let url_string = window.location.href;
    let url = new URL(url_string);
    let lat = url.searchParams.get("lat");
    let lng = url.searchParams.get("lng");
    let requested_address = {lat: parseFloat(lat), lng: parseFloat(lng)};
    let meetingPoints = getMeetingPoints(requested_address);
    initMap(meetingPoints, requested_address);
};

var getPathname = function() {
    let path = window.location.pathname.split('/');
    var pathname = path[path.length - 1];
    return pathname
};

var disableButton = function() {
    $('#dispo-enseignants-button').prop("disabled", true);
    $('#select-button').prop("disabled", true);

    $('#sign-up-button-js').prop("disabled", true);
    $("#formules-button").prop("disabled", true);
    $("#paiement-button").hide()
};

var setInputsvalue = function(id, zipcode, city) {
    $('#data-zipcode-id').val(id);
    $('#data-zipcode').val(zipcode);
    $('#data-city').val(city);
}

var getSelectedZipData = (list) => {
    let selectedZip = list[0];
    let selectedZipValue = $('div[data-value].active').attr('data-value');
    if(undefined !== selectedZipValue) {
        selectedZipValue = decodeURIComponent(selectedZipValue);
        selectedZip = list?.find((item) => item.value == selectedZipValue) || selectedZip;
    }
    return selectedZip;
}

var updateSelectedValueAndEnableSubmit = () => {};

var updateInputAddress = function(position) {
    var lat = position.coords.latitude;
    var lng = position.coords.longitude;
    var latlng = new google.maps.LatLng(lat, lng);
    var geocoder = new google.maps.Geocoder();
    var input = document.getElementById("address-autocomplete");
    var button = $('#dispo-enseignants-button');

    geocoder.geocode({ 'latLng': latlng }, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
            var address = (results[0].formatted_address);
            var addressComplete = [];

            input.value = address;
            if (input.value.length != 0) {
                $('#data-latitude').val(lat);
                $('#data-longitude').val(lng);
                for (var i = 0; i < results[0].address_components.length; i++) {
                    for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                        var addressCity = { postal_code: 'zipcode', locality: 'city' };
                        var key = addressCity[results[0].address_components[i].types[j]];
                        $('#data-'+ key).val(results[0].address_components[i].long_name);

                        var streetNumber = { street_number: 'street_number', route: 'route' };
                        var keyStreet = streetNumber[results[0].address_components[i].types[j]];
                        if (keyStreet) {
                            addressComplete.push(results[0].address_components[i].long_name);
                            $('#data-address').val(addressComplete.join(', '));
                        }
                    }
                }
                button.submit();
                button.prop("disabled", false);
            }
        }
    });
}

var initializeAutocomplete = function(button) {
    var errorAddressAutocomplete = document.getElementById("error-autocomplete-google-js");
    var errorMandatoryAutocomplete = document.getElementById("mandatory-autocomplete-js");
    var geolocationButton = $('#geolocation-js');
    var input = document.getElementById("address-autocomplete");
    var options = {
        componentRestrictions: { country: "fr" },
        fields: ["address_components", "geometry", "icon", "name"]
      }

    if (input) {
        var autocomplete = new google.maps.places.Autocomplete(input, options);
        geolocationButton.click(function() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(updateInputAddress);
            }
        });

        google.maps.event.addListener(autocomplete, 'place_changed', onPlaceChanged);

        input.addEventListener("input", () => {
            if (input.value.length == 0) {
                errorAddressAutocomplete.style.display = 'none';
            }
            $('#data-address').val('')
            button.prop("disabled", true);
        });

        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function() {
                errorAddressAutocomplete.style.display = 'none';
            });
        });

        observer.observe(errorMandatoryAutocomplete, { attributes : true, attributeFilter : ['style'] });

        input.addEventListener("focusout", () => {
            setTimeout(function(){
                if ($('#data-address').val() == '' && input.value.length > 0) {
                    errorAddressAutocomplete.style.display = 'block';
                }
            }, 1500);
        })
    }
}

var onPlaceChanged = function() {
    var place = this.getPlace()
    var button = $('#dispo-enseignants-button');
    var errorAddressAutocomplete = document.getElementById("error-autocomplete-google-js");

    for (var i = 0; i < place.address_components.length; i++) {
        for (var j = 0; j < place.address_components[i].types.length; j++) {
            var address = { postal_code: 'zipcode', locality: 'city' };
            var key = address[place.address_components[i].types[j]];
            $('#data-'+ key).val(place.address_components[i].long_name);
        }
    }

    $('#data-address').val(place.name);
    $('#data-latitude').val(place.geometry.location.lat());
    $('#data-longitude').val(place.geometry.location.lng());
    button.prop("disabled", false);
    button.submit();
    errorAddressAutocomplete.style.display = 'none';
}

var getLatLng = function(button, pathname) {
    var input = $("#zip-code-autocomplete");
    var otherInput = ['#data-zipcode', '#data-city', '#data-zipcode-id'];
    var parentInput = document.getElementsByClassName('tunnel-input-group');

    input.focusin(function(){
        var floatingLabel = input.parent().parent().find('.floating-label');
        floatingLabel.animate({ top: '-16px', fontSize: '11px' }, 100);
    });

    if(input.length > 0) {
        input.on('keypress', (e) => {
            if((e.key == 13) && ($('#data-zipcode').val() == "" || $('#data-zipcode').val() == null)) return false;
        });

        input.on("change paste keyup", function(e) {
            if(input.val().length <= 2) {
                otherInput.forEach(function (element) { $(element).val(""); });
                button.prop("disabled", true);
            }
        });

        if($('#data-city').val().length > 0 && $('#data-zipcode').val().length > 0) {
            enableButton(button)
            button.submit();
        }

        input.autocomplete({
            valid: (() => true),
            source: [(query, callback) => {
                if(query.length == 0) return [];
                $.get(
                    `${legacy_url}/api/v1/cities?q=${query}&max_count=50`,
                    (data) => {
                        let results = data.map((item) => {
                            let title = `${item.name} (${item.pc_value})`;
                            return {
                                title: title,
                                zipcode: item.pc_value,
                                name: item.name,
                                id: item.pc_id,
                                value: title,
                            }
                        }).sort((a, b) => a.zipcode - b.zipcode); // or a.title.localeCompare(b.name) if name

                        updateSelectedValueAndEnableSubmit = () => {
                            if(results?.length == 0) return;
                            let selection = getSelectedZipData(results);

                            input.val(selection.title);
                            setInputsvalue(selection.id, selection.zipcode, selection.name);
                            enableButton(button)
                            input.autocomplete("close");
                        }
                        return callback(results);
                    }
                );
            }],
            minLength: 2,
            limit: 50,
            visibleLimit: 4,
            autoselect: true,
            appendMethod: 'replace',
            showHint: false,
        });
        input.on('focusout', (e, ui) => {
            updateSelectedValueAndEnableSubmit();
            if (input.val() == '') {
                var floatingLabel = input.parent().parent().find('.floating-label');
                input.css({ padding: '20px 15px 10px', border: '2px solid #B1B3B5'});
                floatingLabel.animate({ top: '-2px', fontSize: '1rem' }, 100);
            }
        });
        input.on( "autocompleteopen", function(event, ui) {
            if(pathname == "dispo-enseignants") {
                var changeTop = parentInput[0].offsetTop + parentInput[0].offsetHeight;
                var changeWidth = parentInput[0].offsetWidth;
                document.getElementById("ui-id-1").style.setProperty("top", changeTop + "px", "important");
                document.getElementById("ui-id-1").style.setProperty("width", changeWidth + "px", "important");
            }
        });
    }
};

var enableButton = function(button) {
    let inputPassword = $(".input-password-js");

    if (inputPassword.length === 0 || inputPassword.val().length >= minLengthPassword) {
        button.prop("disabled", false);
    }
}

var selectAnswer = function() {
    $(".tunnel-select").click(function(){
        var value = $(this).attr('id');
        $(".tunnel-select").removeClass('select');

        $(this).addClass('select');
        $('#select-answer').val(value);
        $("#select-button").prop("disabled", false);
    });
};

var setCouponLink = function() {
    $('#coupon-form-trigger').click(function() {
        $('#coupon-form-hide-trigger').attr('href', window.location.pathname);
    });
};

var setPaymentFormLinks = function() {
    var action = $('button[type="submit"]').data('url');
    $('#paiement-form').attr('action', action);
    $('#coupon-form-hide-trigger').attr('href', window.location.pathname);
};

var toggleButtons = function() {
    var disclaimerToggle = $('a#show-user-iel-btn');

    if (disclaimerToggle.length == 1) {
        var ielDisclaimer = $("div#iel-disclaimer");
        disclaimerToggle.on('click', function(){ielDisclaimer.toggle()})
    }

    var moreToggle = $('a#show-more-iel-btn');

    if (moreToggle.length == 1) {
        var ielMore = $("div#iel-more");
        moreToggle.off('click');
        moreToggle.on('click', function(){
            ielMore.toggle();
            moreToggle.find('i').toggleClass('fa-angle-up fa-angle-down');
        })
    }

    var moreCodeToggle = $('h3#show-more-code-btn');
    var moreHourToggle = $('h3#show-more-hour-btn');
    var moreExamToggle = $('h3#show-more-exam-btn');

    if (moreCodeToggle.length == 1) {
        var codeMore = $("div#code-more");
        moreCodeToggle.on('click', function(){
            codeMore.toggle();
            moreCodeToggle.find('i').toggleClass('fa-sort-up fa-sort-down');
        })
    }
    if (moreHourToggle.length == 1) {
        var hourMore = $("div#hour-more");
        moreHourToggle.on('click', function(){
            hourMore.toggle();
            moreHourToggle.find('i').toggleClass('fa-sort-up fa-sort-down');
        })
    }
    if (moreExamToggle.length == 1) {
        var examMore = $("div#exam-more");
        moreExamToggle.on('click', function(){
            examMore.toggle();
            moreExamToggle.find('i').toggleClass('fa-sort-up fa-sort-down');
        })
    }
};

var updateCss = function() {
    var input_div = $('input[type!="checkbox"]').parent();
    var checkbox_div = $('input[type="checkbox"]').parent().parent();
    var checkbox_label = $('input[type="checkbox"]').parent();
    input_div.addClass("panel-max-500");
    checkbox_div.addClass("panel-max-500");
    checkbox_label.addClass("label-checkbox");
    $('input[type="text"]:first').focus();
    $('.iel-user-disclaimer').css("margin-top", "40px");
};

var disableLogoLink = function() {
    var logo_link = $('a.navbar-evs-brand');
    logo_link.attr("href", "#").css("pointer-events", "none");
};

var goBackButton = function() {
    $('.tunnel a.previous-question').on('click', function(e){
        e.preventDefault();
        window.history.back();
    });
};

var setTabIndex = function() {
    $(":input:not(:hidden)").each(function (i) {
        $(this).attr('tabindex', i + 1);
    });
};

// Iterates over all required inputs and add two focus callback to show/hide the mandatory explanation
var setupRequiredInputCallbacks = function() {
    // Fetch inputs
    var inputs = $('input,select').filter('[required]:visible');
    $('#first-name-autocomplete').blur(); // disable autofocus on firstname

    inputs.each(function( index ) {
        var input = $(this);
        if (input.attr('id') == 'address-autocomplete') {
            return;
        }

        if (input.val() != '') {
            var floatingLabel = input.parent().parent().find('.floating-label');
            floatingLabel.css({ top: '-16px', fontSize: '11px' });
            input.css({ padding: '20px 15px 10px'});
        }

        if (input.css('border-color') == 'rgb(231, 76, 60)') {
            if (!!input.val()) { // quick and dirty non empty value
                var warning = input.parent().siblings('.invalid-field-mention-js') || input.siblings('.invalid-field-mention-js');
            } else if (input.attr('id') == 'zip-code-autocomplete') {
                var warning = input.parent().parent().siblings('.mandatory-field-mention-js')
            } else {
                var warning = input.parent().siblings('.mandatory-field-mention-js') || input.siblings('.mandatory-field-mention-js');
            }

            warning.show()
        }

        // On focusout, if empty, show warning
        input.focusout(function (e){
            var floatingLabel = input.parent().parent().find('.floating-label');

            if(input.val() == ''){
                var clearButton = input.parent().find('.clear-input-js');
                if (input.attr('id') == 'zip-code-autocomplete') {
                    var warning = input.parent().parent().siblings('.mandatory-field-mention-js')
                } else {
                    var warning = input.parent().siblings('.mandatory-field-mention-js') || input.siblings('.mandatory-field-mention-js');
                }

                input.css({ border: '2px solid #E94F37', padding: '15px' });
                floatingLabel.animate({ top: '-2px', fontSize: '1rem' }, 100);
                warning.show();
                clearButton.hide();
            } else {
                if (input.attr('id') == 'phone-number-autocomplete' && $("#error-phone-number-js").css('display') == 'block') {
                    input.css({ padding: '20px 15px 10px', border: '2px solid #E74C3C' });
                } else {
                    input.css({ padding: '20px 15px 10px', border: '2px solid #B1B3B5'});
                }
                floatingLabel.animate({ top: '-16px', fontSize: '11px' }, 100);
            }
        });

        // On Focusin, hide warning
        input.focusin(function (e){
            if (input.attr('id') == 'zip-code-autocomplete') {
                var warning = input.parent().parent().siblings('.mandatory-field-mention-js')
            } else {
                var warning = input.parent().siblings('.mandatory-field-mention-js') || input.siblings('.mandatory-field-mention-js');
            }
            var clearButton = input.parent().find('.clear-input-js');
            var floatingLabel = input.parent().parent().find('.floating-label');
            var formatMessage = input.parent().siblings('.invalid-field-mention-js') || input.siblings('.invalid-field-mention-js');

            input.css({ padding: '20px 15px 10px', border: '2px solid #494E5A'});
            floatingLabel.animate({ top: '-16px', fontSize: '11px' }, 100);
            warning.hide();
            clearButton.show();
            formatMessage.hide();

            clearButton.click(function(){
                input.val("");
                warning.show();
                floatingLabel.animate({ top: '-2px', fontSize: '1rem' }, 100);
                input.css({ border: '2px solid #E94F37', padding: '15px' });
                clearButton.hide();
            });
        });
    });
};

var checkPhoneNumber = function() {
    var inputPhoneNumber = $("#phone-number-autocomplete");
    var regexPhone = new RegExp(/^(?:|0)\s*[6-7](?:[\s.-]*\d{2}){4}$/);
    var errorPhoneNumber = $("#error-phone-number-js");

    inputPhoneNumber.on('focusout', () => {
        var txt = inputPhoneNumber.val();
        var size = txt.length;
        var verifyPhoneNumber = txt.match(regexPhone);

        if (verifyPhoneNumber && size == 10) {
            errorPhoneNumber.hide();
            inputPhoneNumber.css({ border: '2px solid #E94F37' });
        } else {
            errorPhoneNumber.show();
        };
    })
}

var setupInfoPasswordInputCallbacks = function() {
    let input = $(".input-password-js");
    let infoPassword = $('.info-password-mention-js')
    let signUpButton = $('#sign-up-button-js')

    input.on("input", function() {
        let inputLength = $(this).val().length
        infoPassword.hide();
        signUpButton.prop("disabled", false);

        if (inputLength < minLengthPassword && inputLength > 0) {
            infoPassword.show();
            signUpButton.prop("disabled", true);
        } else if (inputLength === 0) {
            signUpButton.prop("disabled", true);
        }
    })
};

$(document).ready(function() {
    setTabIndex();
    disableButton();

    // CTA management
    var pathname = getPathname();

    var button = null;
    if(pathname == "dispo-enseignants") {
        button = $('#dispo-enseignants-button');
    } else if(pathname == "sign-up") {
        button = $('#sign-up-button-js');
        updateCss();
        checkPhoneNumber();
    } else if(pathname == "paiement") {
        disableLogoLink();
    }
    if (button != null) {
        if (pathname != "dispo-enseignants") {
            getLatLng(button, pathname);
        }
    }
    if(pathname != "dispo-enseignants") {
        setupRequiredInputCallbacks();
    }

    selectAnswer();
    setCouponLink();
    setPaymentFormLinks();
    toggleButtons();
    goBackButton();
    showGoogleMap();
    changeQuantity();
    setupInfoPasswordInputCallbacks();
});

google.maps.event.addDomListener(window, 'load', function() {
    var pathname = getPathname();

    if(pathname == "dispo-enseignants") {
        var button = $('#dispo-enseignants-button');
        initializeAutocomplete(button);
    }
});
